import {hasWindow} from '../../common/constants'

export default ({children}) => (hasWindow ? children : null)
